import React from "react";
import ProductCard from "web/react/components/product-card/react/product-card";
import { HStack } from "web/react/emo/h-stack";
import {
    ProductCardDetails,
    ProductCardPrice,
    ProductCardWishlist,
    ProductImage,
} from "web/react/emo/product-card";
import { VStack } from "web/react/emo/v-stack";
import { useEditorialAnalytics } from "web/react/hooks/use-editorial-analytics";
import { ProductCardSerializer } from "web/types/serializers";

interface EditorialProductCardProps {
    product: ProductCardSerializer;
    position: number;
    productPosition: number;
    editorialLabel: string;
    gender: "womenswear" | "menswear" | "mixed";
    franchise: string;
    tags: string[];
    isSponsored: boolean;
}

export function EditorialProductCard({
    product,
    position,
    productPosition,
    editorialLabel,
    franchise,
    tags,
    gender,
    isSponsored,
}: EditorialProductCardProps): React.ReactElement {
    const { containerRef, sendClickEvent } = useEditorialAnalytics({
        label: "product",
        editorialLabel,
        franchise,
        tags,
        position,
        isSponsored,
        productPosition,
        productId: product.id,
        buyOptionId: product.link_id,
        gender: gender,
    });

    return (
        <div ref={containerRef} data-testid="editorial-product-card">
            <ProductCard product={product}>
                <VStack spacing="sm">
                    <button
                        data-testid="editorial-product-image"
                        onClick={() => sendClickEvent("image")}
                    >
                        <ProductImage
                            width={218}
                            height={290}
                            shouldRenderLeadLinkInImage={isSponsored}
                        />
                    </button>
                    <VStack spacing="xxs">
                        <HStack justify="space-between">
                            <ProductCardPrice size={"lg"} style={"secondary"} />
                            <ProductCardWishlist
                                beforeOnClick={() => sendClickEvent("link")}
                                isSavedForLater={product.is_saved_for_later}
                            />
                        </HStack>
                        <ProductCardDetails
                            beforeOnClick={() => sendClickEvent("link")}
                            shouldRenderLeadLink={isSponsored}
                        />
                    </VStack>
                </VStack>
            </ProductCard>
        </div>
    );
}
